import React, { useState } from "react";
import logo from "../../src/Images/img/logo.png";
import { useLocation } from "react-router-dom";
import * as query from "../query";
import ClipLoader from "react-spinners/ClipLoader";
import { FaCircleCheck, FaCircleExclamation } from "react-icons/fa6";
function RecoveryPassword() {
  const { state } = useLocation();
  const { vcode, id } = state;
  const [process, setProcess] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [formData, setFormData] = useState({
    newInput: "",
    confirmInput: "",
  });
  //console.log(vcode);

  const handleSubmit = (event) => {
    event.preventDefault();
    let $newPass = formData.newInput;
    let $confirmPass = formData.confirmInput;

    setProcess(false);

    if ($newPass !== "" && $confirmPass !== "") {
      if ($newPass === $confirmPass) {
        let reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
        if (reg.test($newPass) === false) {
          setAlertMsg("Invalid password format");
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        } else {
          setShowAlert(false);
          setProcess(true);
          updateRecoveryHandler($newPass, vcode, id);
        }
      } else {
        setAlertMsg("New password and confirm password must be the same.");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      }
    } else {
      setAlertMsg("New password and confirm password cannot be empty.");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setShowAlert(false);
  };

  const updateRecoveryHandler = async (newPass, vCode, id) => {
    const response = await query.fetchOpenRequest("secured/recovery/update", {
      newPass,
      vCode,
      id,
    });

    if (!response.ok) {
      const resData = await response.json();

      if (resData.response.code === 500) {
        setProcess(false);
        throw new Error(resData.response.errorMessage);
      } else throw new Error("something went wrong!");
    }

    const resData = await response.json();

    if (resData.result.result === true) {
      setProcess(false);
      setCompleted(true);
      setSuccess(true);
      setFormData({
        newInput: "",
        confirmInput: "",
      });
    } else {
      setProcess(false);
      setCompleted(true);
      setSuccess(false);
      setFormData({
        newInput: "",
        confirmInput: "",
      });
    }
  };

  return (
    <div>
      <header
        id="js-header"
        class="u-header u-header--sticky-top u-header--show-hide u-header--toggle-section"
        data-header-fix-moment="100"
        data-header-fix-effect="slide"
      >
        <div class="u-header__section u-shadow-v27 g-bg-white g-transition-0_3 g-py-12 g-py-20--md">
          <nav class="navbar navbar-expand-lg py-0 g-px-15">
            <div class="container g-pos-rel">
              <a href={"https://www.questquote.com"}>
                <img
                  class="u-header__logo-img u-header__logo-img--main g-width-200"
                  src={logo}
                  alt="Questquote logo"
                />
              </a>
            </div>
          </nav>
        </div>
      </header>

      {completed ? (
        <div>
          {success ? (
            <section class="g-bg-gray-light-v5">
              <div class="container g-py-100">
                <div class="row justify-content-center">
                  <div class="col-sm-8 col-lg-5">
                    <div class="u-shadow-v21 g-bg-white rounded g-py-40 g-px-30">
                      <header class="text-center mb-4">
                        <div class="g-mb-35">
                          <FaCircleCheck size={60} color={"#2ECC71"} />
                        </div>
                        <h3 class="h3 g-color-black g-font-weight-600">
                          Process Completed!
                        </h3>
                      </header>
                      <div class="g-mb-35" style={{ textAlign: "center" }}>
                        <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-18">
                          Your password reset was successful.
                        </label>
                        <label class="g-color-gray-dark-v2 g-font-weight-300 g-font-size-18">
                          Please log in to the app using your new password.
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <section class="g-bg-gray-light-v5">
              <div class="container g-py-100">
                <div class="row justify-content-center">
                  <div class="col-sm-8 col-lg-5">
                    <div class="u-shadow-v21 g-bg-white rounded g-py-40 g-px-30">
                      <header class="text-center mb-4">
                        <div class="g-mb-35">
                          <FaCircleExclamation size={60} color={"#F39C12"} />
                        </div>
                        <h3 class="h3 g-color-black g-font-weight-600">
                          Process Failure!
                        </h3>
                      </header>
                      <div class="g-mb-35" style={{ textAlign: "center" }}>
                        <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-18">
                          Your password reset has failed because the reset link
                          has expired.
                        </label>
                        <label class="g-color-gray-dark-v2 g-font-weight-300 g-font-size-18">
                          Please request a new reset link.
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      ) : (
        <section class="g-bg-gray-light-v5">
          <div class="container g-py-100">
            <div class="row justify-content-center">
              <div class="col-sm-8 col-lg-5">
                <div>
                  {process ? (
                    <div class="u-shadow-v21 g-bg-white rounded g-py-40 g-px-30">
                      <header class="text-center mb-4">
                        <h2 class="h2 g-color-black g-font-weight-600">
                          Processing...
                        </h2>
                      </header>
                      <div class="g-py-60">
                        <ClipLoader
                          color={"#2ECC71"}
                          loading={process}
                          size={120}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    </div>
                  ) : (
                    <div class="u-shadow-v21 g-bg-white rounded g-py-40 g-px-30">
                      <header class="text-center mb-4">
                        <h2 class="h2 g-color-black g-font-weight-600">
                          Reset Password
                        </h2>
                      </header>
                      <form class="g-py-15" onSubmit={handleSubmit}>
                        <div class="mb-4" style={{ textAlign: "left" }}>
                          <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                            New Password:
                          </label>
                          <input
                            class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover rounded g-py-15 g-px-15"
                            type="password"
                            name="newInput"
                            id="newInput"
                            value={formData.newInput}
                            onChange={handleChange}
                          />
                        </div>

                        <div class="g-mb-35" style={{ textAlign: "left" }}>
                          <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                            Confirm Password:
                          </label>
                          <input
                            class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover rounded g-py-15 g-px-15 mb-3"
                            type="password"
                            name="confirmInput"
                            id="confirmInput"
                            value={formData.confirmInput}
                            onChange={handleChange}
                          />
                        </div>

                        <div class="g-mb-35" style={{ textAlign: "left" }}>
                          <label class="g-color-gray-dark-v2 g-font-weight-300 g-font-size-13">
                            Password minimum length is 8 characters and must
                            containing numbers, lowercase and uppercase letters.
                          </label>
                        </div>

                        <div class="mb-4">
                          {process === true ? (
                            <button
                              class="btn btn-md btn-block u-btn-primary rounded g-py-13"
                              type="button"
                              disabled
                            >
                              Submitting
                            </button>
                          ) : (
                            <button
                              class="btn btn-md btn-block u-btn-primary rounded g-py-13"
                              type="submit"
                            >
                              Submit
                            </button>
                          )}
                        </div>

                        {showAlert && (
                          <div
                            class="alert alert-danger g-mt-30--lg"
                            role="alert"
                            style={{ textAlign: "left" }}
                          >
                            <strong>{alertMsg}</strong>
                          </div>
                        )}
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default RecoveryPassword;
